export enum CreateEntryActionType {
    Dashboard = 'dashboard',
    Dataset = 'dataset',
    Connection = 'connection',
    Report = 'report',
    Editor = 'editor',
    QL = 'ql',
    Wizard = 'wizard',
}

export const CHUNK_SIZE = 100;
